"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logFormatter = exports.sleep = exports.sleepAndReject = void 0;
/**
 * Sleeps for a given timespan in MS and rejects
 * @param timeSpan Timespan in MS before rejecting the resulting promise.
 */
function sleepAndReject(timeSpan) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const id = setTimeout(() => {
                clearTimeout(id);
                reject(`Timeout exceeded after ${timeSpan}ms`);
                resolve(null);
            }, timeSpan);
        });
    });
}
exports.sleepAndReject = sleepAndReject;
/**
 * Sleeps for a give time in milli seconds.
 * @param ms Milli seconds to sleep.
 */
function sleep(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    });
}
exports.sleep = sleep;
/**
 * Default log string formatter for resiliency proxies.
 * @param requestId Guid of the request.
 * @param state Log state message if any.
 * @param error Error of log entry if any.
 */
function logFormatter(state, requestId, error) {
    if (requestId && state && error && error.message) {
        return `${requestId} ${state} with error "${error.message}"`;
    }
    if (state && error && error.message) {
        return `${state} with error "${error.message}"`;
    }
    if (requestId && state) {
        return `${requestId} ${state}`;
    }
    if (state) {
        return state;
    }
    if (requestId && error && error.message) {
        return `${requestId} ${error.message}`;
    }
    if (error && error.message) {
        return error.message;
    }
    throw new Error('Invalid inputs provided for log formatter');
}
exports.logFormatter = logFormatter;
//# sourceMappingURL=utils.js.map